

import { createApp } from 'vue'
import App from './App.vue'
// import router from './router'   // <- 移除静态导入

import { createPinia } from 'pinia'
import piniaPluginPersist from 'pinia-plugin-persist'

import vConsoleMini, { resolveDebugAccess } from '@/hooks/vConsoleMini'

import i18n from "@/i18n";
import { initRem } from '@/common/ts/adaptation';



initRem({
    desktopFontSize: 14,
    mobileMinFontSize: 11,
    mobileMinWidth: 320,
});

const pinia = createPinia()
pinia.use(piniaPluginPersist)

    // 启动阶段先判断当前标签页是否获得限时调试权限，再决定是否加载 vConsole。
    ; (async () => {
        
        const app = createApp(App)

        // 先注册 i18n 和 pinia，确保后续动态导入的路由/组件能安全使用 useI18n
        app.use(pinia)
            .use(i18n);

        // 动态导入 router，避免在模块解析阶段同步加载页面组件导致 useI18n 在插件注册前被调用
        const { default: router } = await import('./router')
        app.use(router)

        const isDebug = await resolveDebugAccess() || window.location.href.includes('debug=1')
        isDebug && app.use(vConsoleMini, {
            showVConsole: true,
            exposeGlobal: false,
            maxLogs: 2000
        })

        app.mount('#app')
    })()
